<template>
  <div>
    <panel title="Procedury">
      <w-table
        entity-type="procedure"
        :hide-add-button="true"
        :actions="actions"
        :columns="columns"
        :data="list"
        :total="count"
        @add="goToAdd"
        @edit="goToEdit($event.id)"
        @delete="showDeleteDialog($event.id)"
        @setStatus="openStatusPicker"
        @view="goToProcedure($event.id)"
      />
    </panel>

    <pick-status-modal
      :id="statusPickerProcedureId"
      :show="showStatusPicker"
      :object="statusPickerProcedure"
      @update="saveStatus"
      @cancel="closeStatusPicker"
    />
  </div>
</template>

<script>
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { procedureManageMixin } from '@/mixins/procedure/procedureManage';
import { DEFAULT_TABLE_ACTIONS, SET_STATUS_ACTION, VIEW_ACTION } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania procedur.',
  getError: 'Wystąpił błąd podczas pobierania danych procedury.',
  added: 'Dodano procedurę.',
  addError: 'Nie udało się dodać procedury.',
  updated: 'Zaktualizowano dane procedury.',
  updateError: 'Nie udało się zaktualizować danych procedury.',
  deleteConfirm: 'Czy na pewno chcesz usunąć procedurę?',
  deleted: 'Usunięto procedurę.',
  deleteError: 'Nie udało się usunąć procedury.'
};

// @vuese
// Lista procedur
// @group Procedure
export default {
  components: { WTable },

  mixins: [listMixin('procedure', messages), procedureManageMixin],

  data() {
    return {
      columns: [{ name: 'name', displayName: 'Nazwa', action: VIEW_ACTION.event }],
      actions: [VIEW_ACTION, SET_STATUS_ACTION, ...DEFAULT_TABLE_ACTIONS]
    };
  },

  methods: {
    // @vuese
    // Przenosi do dodania
    goToAdd() {
      this.$router.push({ name: 'procedureCreate' });
    },

    // @vuese
    // Przenosi do szczegółów procedury
    goToProcedure(procedureId) {
      this.$router.push({ name: 'procedureDetails', params: { procedureId } });
    }
  }
};
</script>
